import { render } from "./MkrClickIcon.vue?vue&type=template&id=8b2c0ed6"
import script from "./MkrClickIcon.vue?vue&type=script&lang=js"
export * from "./MkrClickIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__